import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import AppBar from "@mui/material/AppBar";
import { Toolbar, Typography, Box, Button } from "@mui/material";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import AddContractRequestForm from "../components/AddContractRequestForm";
import { useTheme } from "@mui/material/styles";
import {
  getCRTStatuses,
  getInternalCRTRequests,
  getPositionRequestTypes,
} from "../../../store/contractuals/actions";
import AdvancedDataTable from "../../common/components/AdvancedDataTable";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

const ActiveButton = {
  float: "left",
  borderRadius: "8px",
  height: "40px",
  border: `1px solid rgb(7, 142, 206)`,
  display: "flex",
  color: "#fff",
  alignItems: "left",
  fontSize: ".75rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "initial",
  backgroundColor: "rgb(7, 142, 206)",
  "&:hover": {
    backgroundColor: "#f0f2f5",
  },
};

export const CRT_STATUS_COLOR_MAP = {
  "Pending for Verification": {
    color: "warning",
    desc: "The request created and sent for verification by HR",
    icon: "pending",
  },
  "Pending for Approval": {
    color: "#66b2ff",
    desc: "The request verified and sent for approval by DAF",
    icon: "pending",
  },
  "Verification Rejected": {
    color: "warning",
    desc: "The request was rejected on verification level",
    icon: "cancel",
  },
  "Approval Rejected": {
    color: "danger",
    desc: "Verified request was rejected on approval level",
    icon: "cancel",
  },
  "Pending for MIFOTRA Review": {
    color: "#ffa500",
    desc: "Request approved and sent for MIFOTRA Review",
    icon: "pending",
  },
  "Pending for MIFOTRA Verification": {
    color: "info",
    desc: "Request review by MIFOTRA and sent for Verification",
    icon: "pending",
  },
  Approved: { color: "success", desc: "The request was approved by MIFOTRA" },
  "Rejected on Review": {
    color: "danger",
    desc: "Request rejected by MIFOTRA Reviewer",
    icon: "cancel",
  },
  "Rejected on MIFOTRA Verifier": {
    color: "danger",
    desc: "Request rejected by MIFOTRA Verifier",
    icon: "cancel",
  },
  "Rejected on MIFOTRA Approver": {
    color: "danger",
    desc: "Request rejected by MIFOTRA Approver",
    icon: "cancel",
  },
};

const InternalCRTRequests = (props) => {
  const {
    getInternalCRTRequests,
    user,
    loading,
    internalCRTRequests,
    crtStatuses,
    getCRTStatuses,
    positionRequestTypes,
    getPositionRequestTypes,
  } = props;
  const { hasPermissions } = useRequiredAuth();
  const theme = useTheme();

  const [showRequestForm, setShowRequestForm] = useState(false);
  const [configLoading, setConfigLoading] = useState({
    status: true,
    requestType: true,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (!crtStatuses.length) {
      getCRTStatuses((loading) => {
        setConfigLoading(() => ({ ...configLoading, status: loading }));
      });
    } else {
      setConfigLoading(() => ({ ...configLoading, status: false }));
    }
    if (!positionRequestTypes.length) {
      getPositionRequestTypes((loading) => {
        setConfigLoading(() => ({ ...configLoading, requestType: loading }));
      });
    } else {
      setConfigLoading(() => ({ ...configLoading, requestType: false }));
    }
    if (!internalCRTRequests.length) {
      getInternalCRTRequests({}, (loading) => {
        setIsLoading(loading);
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      <Box sx={{ display: "flex", width: "100%" }}>
        <div className="w-100">
          <AppBar
            position="static"
            elevation={0}
            style={{ overflow: "hidden" }}
            className="app-bar w-100"
          >
            <Toolbar className="d-flex align-items-center justify-content-between">
              <Typography
                variant="h6"
                noWrap
                component="div"
                // sx={{ display: { xs: "none", sm: "block" } }}
              >
                <span>CONTRACTUAL</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span style={{ color: "rgb(7, 142, 206)" }}>
                  <span style={{ color: "rgb(7, 142, 206)" }}>Requests</span>
                </span>
              </Typography>

              {hasPermissions(["IS_HR"]) && (
                <Button
                  onClick={() => {
                    setShowRequestForm(true);
                  }}
                  style={{
                    ...ActiveButton,
                    // padding: theme.spacing(1.5, 1.5, 1.5, 1.5),
                    float: "right",
                  }}
                  size="md"
                >
                  <span className="material-icons">add</span>Create Request
                </Button>
              )}
            </Toolbar>
          </AppBar>

          <div
            style={{
              padding: theme.spacing(0.4),
              height: "auto",
              maxHeight: "auto",
              backgroundColor: "#fff",
              borderRadius: "0.5rem",
              overflow: "visible",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
            }}
          >
            <AdvancedDataTable
              data={internalCRTRequests}
              isLoading={isLoading}
              isBackdropLoading={false}
              columns={[
                {
                  label: "Request Type",
                  accessor: "requestTypeName",
                },
                {
                  label: "Position Name",
                  accessor: "name",
                  isCopyable: true,
                  sortable: true,
                },
                {
                  label: "Level Name",
                  accessor: "levelName",
                },
                {
                  label: "Posts",
                  accessor: "numberOfPost",
                  sortable: true,
                },
                {
                  label: "End Date",
                  accessor: "endDate",
                  format: "date",
                  sortable: true,
                },
                {
                  label: "Last Change",
                  accessor: "updatedOn",
                  format: "date",
                  sortable: true,
                },
                {
                  label: "Status",
                  accessor: "statusName",
                  format: "status",
                  formatOptions: {
                    variant: "outlined",
                    tooltip: (status) =>
                      CRT_STATUS_COLOR_MAP[status]?.desc || "",
                    color: (status) =>
                      CRT_STATUS_COLOR_MAP[status]?.color || "",
                    icon: (status) =>
                      CRT_STATUS_COLOR_MAP[status]?.icon || null,
                  },
                },
              ]}
              filters={{
                requestTypeId: {
                  type: "select",
                  label: "Request type",
                  loading: configLoading.requestType,
                  options: positionRequestTypes.map((item) => ({
                    label: item.name,
                    value: item.id,
                  })),
                },
                statusId: {
                  type: "select",
                  label: "Status",
                  loading: configLoading.status,
                  options: crtStatuses.map((item) => ({
                    label: item.name,
                    value: item.id,
                  })),
                },
              }}
              showSearch={true}
              onDeepSearch={(search) => {
                alert("Perform server-side search with: " + search);
              }}
              pageCount={1}
              pageSize={pageSize}
              onPageChange={(e) => console.log("Change page to:", e.selected)}
              onPageSizeChange={(size) => setPageSize(size)}
              enableRowSelection={true}
              selectedRows={selected}
              onSelectRow={(row, isSelected) => {
                setSelected((prev) =>
                  isSelected
                    ? [...prev, row.id]
                    : prev.filter((id) => id !== row.id)
                );
              }}
              onSelectAll={(selectAll) => {
                setSelected(
                  selectAll ? internalCRTRequests.map((r) => r.id) : []
                );
              }}
              enableExpandRow={true}
              renderExpandedRow={(row) => (
                <div style={{ padding: "10px", background: "#f9f9f9" }}>
                  <strong>Expanded Content:</strong> More info about {row.name}
                </div>
              )}
              actionsRenderer={(row) => [
                {
                  permissions: ["IS_DAF"],
                  type: "icon",
                  tooltip: "View",
                  icon: VisibilityRoundedIcon,
                  onClick: () => alert("View: " + row.user.name),
                },
                {
                  type: "button",
                  label: "Edit",
                  icon: EditRoundedIcon,
                  color: "primary",
                  onClick: () => alert("Edit: " + row.user.name),
                },
              ]}
            />
          </div>
        </div>
      </Box>

      {showRequestForm && (
        <AddContractRequestForm setShowRequestForm={setShowRequestForm} />
      )}
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  internalCRTRequests,
  crtStatuses,
  positionRequestTypes,
}) => {
  return {
    user,
    loading,
    internalCRTRequests,
    crtStatuses,
    positionRequestTypes,
  };
};
export default connect(mapStateToProps, {
  getInternalCRTRequests,
  getCRTStatuses,
  getPositionRequestTypes,
})(InternalCRTRequests);
